var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-pie"},[_c('AppPie',{attrs:{"value":_vm.signins,"width":130,"height":130,"horizontal":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }